export default __webpack_public_path__ + "static/media/branch2.3c689eff.png";